import { Controller } from "@hotwired/stimulus"

// Live preview for the drip email body. The body is raw HTML/Liquid (the
// Assembler microservice renders the Liquid at send time), so we mirror it into
// a sandboxed <iframe> as-is — no WYSIWYG that would mangle the markup. Merge
// tags like {{ member.first_name }} show literally, which is the correct
// "template" preview. (#218 Phase 1)
//
// Targets:
//   source  - the <textarea> holding the body
//   frame   - the <iframe> we render into
export default class extends Controller {
  static targets = ["source", "frame"]

  connect() {
    this.render()
  }

  // Debounced repaint as the author types.
  update() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.render(), 150)
  }

  render() {
    if (!this.hasFrameTarget || !this.hasSourceTarget) return
    this.frameTarget.srcdoc = this.documentMarkup(this.sourceTarget.value)
  }

  documentMarkup(body) {
    const safe = body && body.trim().length ? body : this.emptyState
    return `<!doctype html><html><head><meta charset="utf-8">
      <style>body{font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:#1a2540;margin:16px;line-height:1.5}</style>
      </head><body>${safe}</body></html>`
  }

  get emptyState() {
    return `<p style="color:#8a8676">Your email preview appears here as you type.</p>`
  }
}
